const window = require('global/window')
const Web3 = require('web3')
const web3 = window.tomoWeb3 || window.web3

export {Web3 as Web3};
export {web3 as web3};
export default class Web3Services {
  static async web3Read () {
    const netId = await this.getNetwork()
    return new Web3(new Web3.providers.HttpProvider(netId == 89 ? 'https://rpc.testnet.tomochain.com' : 'https://rpc.tomochain.com'));
  }
  static async onSignMessage (address, nonce) {
    // console.log(323232, nonce, address)
    let p1 = new Promise((resolve, reject) => {
      try {
        web3.personal.sign(web3.fromUtf8(nonce), address, (err, signature) => {
          if (err) return resolve(err)
          return resolve({ address, signature })
        })
      } catch (error) {
        return reject(error)
      }
    })
    let p2 = new Promise(function (resolve, reject) {
      setTimeout(() => reject('Request timeout'), 30000)
    })
    return Promise.race([p1, p2])
  }

  static async enableMetaMask () {
    return new Promise(async (resolve, reject) => {
      web3.currentProvider.enable()
        .then((accounts) => {
          resolve(accounts)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  static async estimateGas (rawTransaction) {
    return new Promise(async (resolve, reject) => {
      web3.eth.estimateGas(rawTransaction, (err, res) => {
        if (err) {
          reject(err)
        } else {
          resolve(res)
        }
      })
    })
  }

  static async getNetwork () {
    return new Promise(async (resolve, reject) => {
      web3.version.getNetwork((err, netId) => {
        if (err) {
          reject(err)
        } else {
          resolve(netId)
        }
      })
    })
  }

  static async getNonce (address) {
    return new Promise(async (resolve, reject) => {
      web3.eth.getTransactionCount(address, (err, res) => {
        if (err) {
          resolve(0)
        }
        resolve(res)
      })
    })
  }
}
